<template>
  <div>
    <v-tabs>
      <v-tab v-for="(link, index) in links" :key="index">
        <v-btn text exact :to="link.path">{{ link.name }}</v-btn>
      </v-tab>
    </v-tabs>
    <router-view></router-view>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { hasRole } from "../util";

export default {
  computed: {
    ...mapGetters(["isAdmin", "currentUser"]),
    showActivity() {
      return this.isAdmin || hasRole(this.currentUser, "overlord");
    },
    links() {
      let id = this.$route.params.id;
      const links = [
        { name: "CM Scorecard", path: `/org/${id}/staff` },
        { name: "Client Contact", path: `/org/${id}/staff/client-contact` },
        {
          name: "Paralegal Stats",
          path: `/org/${id}/staff/paralegal-stats`
        },
        {
          name: "Attorney Stats",
          path: `/org/${id}/staff/attorney-stats`
        },
        {
          name: "File Review",
          path: `/org/${id}/staff/file-review`
        }
      ];
      if (this.showActivity) {
        links.push({ name: "Activity", path: `/org/${id}/staff/activity` });
      }
      return links;
    }
  }
};
</script>

<style scoped></style>
